import { render, staticRenderFns } from "./FormItemFile.vue?vue&type=template&id=03b5ac54&scoped=true"
import script from "./FormItemFile.vue?vue&type=script&lang=js"
export * from "./FormItemFile.vue?vue&type=script&lang=js"
import style0 from "./FormItemFile.vue?vue&type=style&index=0&id=03b5ac54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b5ac54",
  null
  
)

export default component.exports